import Peg from "./Peg";

const RowZero = ({allColors, setSelectedColor, selectedColor}) => {

  const handleClick = (ev) => {
    setSelectedColor(ev.currentTarget.style['background-color']);
  }  


  return (
    <div className="rowZero">
      {(allColors.map((col,j) => 
        <Peg pegColor={col} id={`0-${j}`} key={`0-${j}`} selectedColor={selectedColor} handleClick={handleClick} />))}
    </div>
  );
}

export default RowZero;